import React, { useCallback, MouseEvent } from 'react'
import { CellProps, Renderer } from 'react-table'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import { getFavouriteSelector } from '../../../store/selectors'
import { updateFavouritesRequest } from '../../../store/actions'
import IconButton from '@mui/material/IconButton'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles({
  button: {
    '&:hover': {
      transition: 'none',
    },
  },
  starIcon: {
    color: '#ff8c00',
  },
})

export const FavouriteCell: Renderer<CellProps<Record<string, string>, string>> = ({ value: symbol }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isFavourite = useSelector((state: RootState) => getFavouriteSelector(state, symbol))
  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      dispatch(updateFavouritesRequest(symbol))
    },
    [dispatch, symbol],
  )

  return (
    <IconButton className={classes.button} size={'small'} onClick={handleClick}>
      {isFavourite ? <StarIcon className={classes.starIcon} /> : <StarBorderIcon className={classes.starIcon} />}
    </IconButton>
  )
}
